import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey) {
  document.body.innerHTML =
    '<div style="min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px;font-family:-apple-system,sans-serif;text-align:center;background:#FDF8F3;color:#5C3D2E;">' +
    '<h1 style="font-size:20px;">Configuration error</h1>' +
    '<p style="max-width:420px;color:#A08070;font-size:14px;line-height:1.6;">Firebase environment variables are missing from this build. This usually means they were added to the hosting dashboard ' +
    '<em>after</em> the last deployment ran — Create React App bakes these in at build time, not runtime. Confirm the variables are saved for the Production environment, then trigger a fresh deployment.</p>' +
    '</div>';
  throw new Error("Firebase config missing — see on-screen message");
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
